// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var ProbabilityScenario;
(function (ProbabilityScenario) {
    ProbabilityScenario[ProbabilityScenario["OneTouch"] = 0] = "OneTouch";
    ProbabilityScenario[ProbabilityScenario["OutOfRange"] = 1] = "OutOfRange";
})(ProbabilityScenario || (ProbabilityScenario = {}));
